/**
 * Merge persisted filters with defaultFilters.
 * - If no valid persisted filters → return defaultFilters.
 * - Only filters defined in defaultFilters are kept.
 * - Preserves persisted `visible` value when available.
 */
export const mergeFilters = (persistedFilters, defaultFilters) => {
	if (!Array.isArray(persistedFilters)) return defaultFilters;

	return defaultFilters.map((df) => {
		const persisted = persistedFilters.find((pf) => pf.id === df.id);
		return {
			...df,
			visible: persisted?.visible ?? df.visible,
		};
	});
};

/**
 * Toggles the visibility of a filter in the Redux slice.
 *
 * @param {Object} state - The current Redux state of the slice.
 * @param {Object} action - The Redux action object.
 * @param {Object} action.payload - The payload containing the filter ID.
 * @param {string|number} action.payload.filterId - The ID of the filter to toggle visibility for.
 *
 * @returns {void} Modifies the state in place (using Immer in Redux Toolkit).
 */
export const toggleReduxSliceFiltersVisibility = (state, action) => {
	const { filterId } = action.payload;
	state.filters = state.filters.map((f) => (f.id === filterId ? { ...f, visible: !f.visible } : f));
};
